import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
    },
    '& .combo-location-select': {
        '& .location-type': {
            marginTop: '-16px',
        },
    },
});

export const Form = styled('div')({
    padding: '24px 16px',
    display: 'grid',
    gridGap: '16px',
    gridTemplateColumns: '100%',
    overflowY: 'auto',
    height: 'calc(var(--100vh) - 154px)',
    '@media (max-width: 768px)': {
        height: 'auto',
    },
});
